import React from "react";
import { useLocation } from "react-router-dom";
import DeliveryForm from "./DeliveryForm";
import InvalidForm from "./invalidform";
import EditFollowUpStageForm from "./EditFollowUpStageForm";
import LostForm from "./LostForm";
import NewEnquiryForm from "./NewEnquiryForm";
import EditSalesDataForm from "../sale/data/EditSalesDataForm";

const formComponents = {
  DELIVERY: DeliveryForm,
  INVALID: InvalidForm,
  LOST: LostForm,
  NEW: NewEnquiryForm,
};

const followUpStages = new Set(["HOT", "COLD", "WARM"]);

const EditEnquiry = () => {
  const { state } = useLocation();
  const ev_stage = state?.ev_stage || {};

  // Check if ev_stage.type exists in predefined forms or follow-up stages
  const SelectedForm =
    formComponents[ev_stage.type] ||
    (followUpStages.has(ev_stage.type) ? EditFollowUpStageForm : EditSalesDataForm);

  return <SelectedForm ev_stage={ev_stage} />;
};

export default EditEnquiry;
